module.exports = __webpack_public_path__ + "static/media/cart-product-1.16e143f3.png";